// JsFromRoutes CacheKey b2f094adabb24d4ed0a361635d2ac02f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  cart: /* #__PURE__ */ definePathHelper('get', '/checkout/cart'),
  create: /* #__PURE__ */ definePathHelper('post', '/gift-card-checkout'),
  checkout: /* #__PURE__ */ definePathHelper('post', '/checkout'),
  shoppingDirectCheckout: /* #__PURE__ */ definePathHelper('get', '/consumer/checkout/shopping_direct_checkout'),
  unsubscribe: /* #__PURE__ */ definePathHelper('put', '/checkout/:slug/unsubscribe'),
  suggestions: /* #__PURE__ */ definePathHelper('get', '/consumer/checkout/suggestions'),
  configuration: /* #__PURE__ */ definePathHelper('get', '/consumer/checkout/configuration'),
  validateEmail: /* #__PURE__ */ definePathHelper('post', '/consumer/checkout/validate_email'),
  verifyEmail: /* #__PURE__ */ definePathHelper('post', '/consumer/checkout/verify_email'),
  saveProgress: /* #__PURE__ */ definePathHelper('patch', '/consumer/checkout/save_progress'),
}
